import { useCallback } from 'react';
import { cn } from '@clarix/ui';
import { DURATION_PRESETS } from './meeting-form.types';

interface DurationChipsProps {
  selectedMinutes: number | null;
  onSelect: (minutes: number) => void;
}

export function DurationChips({
  selectedMinutes,
  onSelect,
}: DurationChipsProps) {
  const handleClick = useCallback(
    (minutes: number) => {
      onSelect(minutes);
    },
    [onSelect],
  );

  return (
    <div className="flex flex-wrap gap-1.5">
      {DURATION_PRESETS.map((preset) => {
        const isActive = selectedMinutes === preset.minutes;
        return (
          <button
            key={preset.minutes}
            type="button"
            onClick={() => handleClick(preset.minutes)}
            className={cn(
              'rounded-full border px-2.5 py-1 text-lg font-medium transition-colors',
              isActive
                ? 'border-indigo-300 bg-indigo-50 text-indigo-700'
                : 'border-border text-muted-foreground hover:border-indigo-200 hover:text-indigo-600',
            )}
          >
            {preset.label}
          </button>
        );
      })}
    </div>
  );
}
